export default {
  "API": process.env.REACT_APP_API
}